import script from "./SocialFundChangeCallPeriodDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./SocialFundChangeCallPeriodDialog.vue?vue&type=script&setup=true&lang=js"

import "./SocialFundChangeCallPeriodDialog.vue?vue&type=style&index=0&id=4e12330e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4e12330e"]])

export default __exports__